// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml from "rescript/lib/es6/caml.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Js_array from "rescript/lib/es6/js_array.js";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Images$LiveRoom from "./assets/Images.bs.js";

function getWidthValue(size) {
  if (size.NAME === "vw") {
    return "" + String(size.VAL) + "vw";
  } else {
    return "" + String(size.VAL) + "px";
  }
}

function getResponsiveWidths(maybeWidths) {
  return Belt_Option.mapWithDefault(maybeWidths, /* [] */0, (function (widths) {
                return Belt_List.map(widths, (function (width) {
                              if (width.NAME === "MinWidth") {
                                var match = width.VAL;
                                return "(min-width: " + String(match[0].VAL) + "px) " + getWidthValue(match[1]);
                              }
                              var match$1 = width.VAL;
                              return "(max-width: " + String(match$1[0].VAL) + "px) " + getWidthValue(match$1[1]);
                            }));
              }));
}

function getDefaultWidth(maybeDefault) {
  return Belt_Option.map(maybeDefault, getWidthValue);
}

function getSizes(sizes) {
  var responsiveWidths = getResponsiveWidths(sizes.responsiveWidths);
  var defaultWidth = Belt_Option.mapWithDefault(Belt_Option.map(sizes.default, getWidthValue), /* [] */0, (function (d) {
          return {
                  hd: d,
                  tl: /* [] */0
                };
        }));
  return Js_array.joinWith(", ", Belt_List.toArray(Belt_List.concat(responsiveWidths, defaultWidth)));
}

function getLargestRendition(renditions) {
  return Belt_List.head(Belt_List.sort(Belt_List.fromArray(renditions), (function (a, b) {
                    return Caml.int_compare(b.width, a.width);
                  })));
}

function getSrc($$default, renditions) {
  if (renditions.length === 0) {
    return Images$LiveRoom.placeholder;
  }
  if ($$default === undefined) {
    return Belt_Option.getExn(getLargestRendition(renditions)).url;
  }
  if (typeof $$default !== "object") {
    return Belt_Option.getExn(getLargestRendition(renditions)).url;
  }
  if ($$default.NAME !== "px") {
    return Belt_Option.getExn(getLargestRendition(renditions)).url;
  }
  var d = $$default.VAL;
  var l = Belt_List.head(Belt_List.sort(Belt_List.fromArray(Belt_Array.keep(renditions, (function (param) {
                      return param.width <= d;
                    }))), (function (a, b) {
              return Caml.int_compare(b.width, a.width);
            })));
  if (l !== undefined) {
    return l.url;
  } else {
    return Belt_Option.getExn(getLargestRendition(renditions)).url;
  }
}

function withLazyLoadingAttribute(element) {
  return React.cloneElement(element, Js_dict.fromList({
                  hd: [
                    "loading",
                    "lazy"
                  ],
                  tl: /* [] */0
                }));
}

function createOnLoadStartListener(onLoadStart, elRef) {
  var loadStartRef = React.useRef(undefined);
  React.useEffect((function () {
          var fn = Belt_Option.getWithDefault(onLoadStart, (function (param) {
                  
                }));
          if (Belt_Option.isSome(onLoadStart)) {
            loadStartRef.current = Caml_option.some(Belt_Option.forEach(Caml_option.nullable_to_opt(elRef.current), (function (r) {
                        r.addEventListener("loadstart", fn);
                      })));
          }
          return (function (param) {
                    var r = elRef.current;
                    if (!(r == null)) {
                      return Belt_Option.forEach(loadStartRef.current, (function (param) {
                                    r.removeEventListener("loadstart", fn);
                                  }));
                    }
                    
                  });
        }), []);
}

function ResponsiveImage(props) {
  var lazyLoading = props.lazyLoading;
  var onPrintError = props.onPrintError;
  var setRef = props.setRef;
  var sizes = props.sizes;
  var imageRenditions = props.imageRenditions;
  var sizes$1 = sizes !== undefined ? sizes : ({
        responsiveWidths: undefined,
        default: undefined
      });
  var setRef$1 = setRef !== undefined ? setRef : React.useRef(null);
  var lazyLoading$1 = lazyLoading !== undefined ? lazyLoading : false;
  var match = React.useState(function () {
        return false;
      });
  var setError = match[1];
  var error = match[0];
  var canShowImage = React.useMemo((function () {
          if (imageRenditions.length !== 0) {
            return !error;
          } else {
            return false;
          }
        }), [
        imageRenditions,
        error
      ]);
  var src = React.useMemo((function () {
          return getSrc(sizes$1.default, imageRenditions);
        }), [
        sizes$1,
        imageRenditions
      ]);
  var match$1 = React.useMemo((function () {
          return Belt_Option.mapWithDefault(getLargestRendition(imageRenditions), [
                      undefined,
                      undefined
                    ], (function (r) {
                        var width = r.width > 0 ? String(r.width) : undefined;
                        var height = r.height > 0 ? String(r.height) : undefined;
                        return [
                                width,
                                height
                              ];
                      }));
        }), [imageRenditions]);
  var srcSet = React.useMemo((function () {
          if (canShowImage) {
            return Js_array.joinWith(",\n", Belt_Array.map(imageRenditions, (function (param) {
                              return "" + param.url + " " + String(param.width) + "w";
                            })));
          }
          
        }), [
        imageRenditions,
        canShowImage
      ]);
  var sizes$2 = React.useMemo((function () {
          if (canShowImage) {
            return getSizes(sizes$1);
          }
          
        }), [
        sizes$1,
        canShowImage
      ]);
  createOnLoadStartListener(props.onLoadStart, setRef$1);
  var el = React.createElement("img", {
        ref: Caml_option.some(setRef$1),
        className: props.className,
        alt: props.alt,
        height: match$1[1],
        sizes: sizes$2,
        src: src,
        srcSet: srcSet,
        width: match$1[0],
        onClick: props.onClick,
        onError: (function ($$event) {
            Belt_Option.map(onPrintError, (function (fn) {
                    Curry._1(fn, $$event);
                  }));
            Curry._1(setError, (function (param) {
                    return true;
                  }));
          }),
        onLoad: props.onLoad
      });
  if (lazyLoading$1) {
    return withLazyLoadingAttribute(el);
  } else {
    return el;
  }
}

var make = ResponsiveImage;

export {
  getWidthValue ,
  getResponsiveWidths ,
  getDefaultWidth ,
  getSizes ,
  getLargestRendition ,
  getSrc ,
  withLazyLoadingAttribute ,
  createOnLoadStartListener ,
  make ,
}
/* react Not a pure module */
